import { render, staticRenderFns } from "./SLAPopoverCard.vue?vue&type=template&id=3d487e49&"
import script from "./SLAPopoverCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./SLAPopoverCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports